import { render } from "./StoreBtn.vue?vue&type=template&id=d2896fde&scoped=true"
import script from "./StoreBtn.vue?vue&type=script&lang=js"
export * from "./StoreBtn.vue?vue&type=script&lang=js"

import "./StoreBtn.vue?vue&type=style&index=0&id=d2896fde&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2896fde"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
